module.exports = __webpack_public_path__ + "img/full3-min.23321b5f.png";